var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowsUpDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70715 1.70711C8.31662 1.31658 7.68346 1.31658 7.29293 1.7071L3.85356 5.14645C3.53858 5.46143 3.76166 6 4.20711 6L11.7929 6C12.2384 6 12.4614 5.46143 12.1465 5.14645L8.70715 1.70711Z",
    fill: "#8F8F8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70715 14.2929C8.31662 14.6834 7.68346 14.6834 7.29293 14.2929L3.85356 10.8536C3.53858 10.5386 3.76166 10 4.20711 10L11.7929 10C12.2384 10 12.4614 10.5386 12.1465 10.8536L8.70715 14.2929Z",
    fill: "#8F8F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsUpDown);
export default __webpack_public_path__ + "static/media/arrows-up-down.b4c321daf2c49944ff50124f342b0d47.svg";
export { ForwardRef as ReactComponent };